import { type VariantProps, cva } from 'class-variance-authority'
import { StarsIcon } from 'lucide-react'
import { ReactNode } from 'react'

import { ControlStatus } from '@/gen/controls/v1/control_status_pb'

import { controlStatusToLemaInsight } from '@/const/label'

import { TextWithIcon } from '@/components/lemmala-design-system/text-with-icon/text-with-icon'

const insightBadgeVariants = cva('rounded', {
  variants: {
    variant: {
      default: '!text-heading-xsmall text-main-foreground-ai',
      inactive: '!text-heading-xsmall text-main-foreground-tertiary',
      highlighted:
        '!text-heading-xsmall bg-main-background-subtle-semantic-ai text-main-foreground-ai p-4',
      /** Restates the verdict on a collapsed card, so it sits below the question. */
      summary: '!text-label-default text-main-foreground-secondary',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

export type InsightBadgeProps = {
  status: ControlStatus
  showIcon?: boolean
  icon?: ReactNode
} & VariantProps<typeof insightBadgeVariants>

export const InsightBadge = ({ status, variant, showIcon = true, icon }: InsightBadgeProps) => {
  return (
    <TextWithIcon
      className={insightBadgeVariants({ variant })}
      text={controlStatusToLemaInsight[status]}
      icon={showIcon ? (icon ?? <StarsIcon className='size-4' />) : undefined}
    />
  )
}
